import { Target } from "lucide-react";
import { usePT } from "@/lib/pt";

export const TargetRing = ({ t }) => {
  const { pt, lang } = usePT();
  if (!t?.goal) return null;
  const pct = Math.min(t.done / t.goal, 1);
  const R = 42, C = 2 * Math.PI * R;
  const hit = t.done >= t.goal;
  return (
    <div className="flex items-center gap-4 rounded-3xl bg-white p-4 shadow-sm" data-testid="partner-target-ring">
      <div className="relative h-28 w-28 shrink-0">
      <svg viewBox="0 0 100 100" className="h-28 w-28 -rotate-90">
        <circle cx="50" cy="50" r={R} fill="none" stroke="#E7F6EE" strokeWidth="11" />
        <circle cx="50" cy="50" r={R} fill="none" stroke={hit ? "#F5B83D" : "#2E9E6B"} strokeWidth="11" strokeLinecap="round"
          strokeDasharray={C} strokeDashoffset={C * (1 - pct)} style={{ transition: "stroke-dashoffset .8s cubic-bezier(.2,.8,.2,1)" }} />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center font-display text-2xl font-extrabold text-[#0D3B2B]" data-testid="partner-target-count">{t.done}/{t.goal}</span>
      </div>
      <div className="min-w-0">
        <p className="flex items-center gap-1 text-sm font-bold text-[#2E9E6B]"><Target className="h-4 w-4" />{pt("Today's target")}</p>
        <p className="font-display text-xl font-extrabold leading-tight text-[#0D3B2B]" data-testid="partner-target-text">
          {hit ? pt("Target done! Great work.") : lang === "hi" ? `आज ${t.goal} में से ${t.done} पिकअप` : `${t.done} of ${t.goal} pickups today`}</p>
        {!hit && <p className="mt-1 text-sm text-[#4A6358]">{t.left} {pt("more to reach your target")}</p>}
      </div>
    </div>
  );
};
